import { useState } from 'react';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { PermissionSelector } from '../../ItemSelector';
import {
    FieldLabelWithError,
    FieldWithErrorProps,
} from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';
import { PermissionsTags, TagsBase } from '~/partials/Tags';
import { Permission } from '~/util/types/permissions';

export function PermissionsField({
    forceDisabled,
    tagOptions = {},
    ...labelProps
}: {
    forceDisabled?: boolean;
    tagOptions?: Partial<
        Omit<TagsBase<Permission>, 'items' | 'editable' | 'onEdit' | 'item'>
    >;
} & FieldWithErrorProps) {
    const field = useFieldContext<Permission[] | null>();
    const [permissionsSelectorOpen, setPermissionsSelectorOpen] =
        useState(false);
    const disabled = useDisableFormContext() || forceDisabled;

    return (
        <FieldLabelWithError<Permission | null> {...labelProps}>
            <PermissionsTags
                items={field.state.value ?? []}
                editable={!disabled}
                highContrast
                onEdit={() => setPermissionsSelectorOpen(true)}
                onRemove={(permission) =>
                    field.handleChange(
                        field.state.value?.filter(
                            (item) => item != permission,
                        ) ?? null,
                    )
                }
                {...tagOptions}
            />
            <PermissionSelector
                open={permissionsSelectorOpen}
                onOpenChange={setPermissionsSelectorOpen}
                initial={field.state.value ?? []}
                onSave={(items) => {
                    const tags = items instanceof Array ? items : [items];
                    field.handleChange(tags ?? null);
                    setPermissionsSelectorOpen(false);
                }}
                tagOptions={tagOptions}
            />
        </FieldLabelWithError>
    );
}
